import React, { useState, useEffect } from 'react'
import { SmallChevronUp, SmallChevronDown } from '../../../../../../images/common'

export const NumberInput = ({
  label = '',
  value = 0,
  onChange = (val) => null,
  onBlur = () => null,
  min = 0,
  step = 1,
  max = 100,
  placeholder = '',
  id
}) => {

  const [currentValue, setCurrentValue] = useState(value)

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  const handleInputChange = (value) => {
    if (value === '') {
      setCurrentValue(null)
      onChange(null)
      return
    }

    const parsed = parseInt(value, 10)
    if (!isNaN(parsed) && parsed >= 0) {
      setCurrentValue(parsed)
      onChange(parsed)
    }
  }

  const handleBlur = () => {
    if (currentValue === '') {
      setCurrentValue(min)
      if(onBlur) {
        onBlur()
      } else {
        onChange(min)
      }
    }
  }

  return (
    <div className='chart-editor-data-streams__input-row'>
      {label &&
        <div className='chart-editor__label'>
          <label className='text-field__label1' htmlFor={id}>{label}</label>
        </div>
      }
      <div className='chart-editor-data-streams-input'>
        <input
          type='number'
          min={min}
          step={step}
          className='chart-editor-data-streams-input__field number-field__input1'
          placeholder={placeholder}
          value={currentValue}
          onChange={(e) => handleInputChange(e.target.value)}
          // onBlur={handleBlur}
          onFocus={() => null}
          name={id}
          id={id}
        />
        <div className='chart-editor-data-streams-input__arrows'>
          <button
            type='button'
            className='chart-editor-data-streams-input__arrow chart-editor-data-streams-input__arrow--up'
            onClick={() => handleInputChange(currentValue + step)}
            disabled={currentValue + step > max}
          >
            <SmallChevronUp />
          </button>
          <button
            type='button'
            className='chart-editor-data-streams-input__arrow chart-editor-data-streams-input__arrow--down'
            onClick={() => handleInputChange(currentValue - step)}
            disabled={currentValue - step < min}
          >
            <SmallChevronDown />
          </button>
        </div>
      </div>
    </div>
  )
}